import { AppDispatch } from "@portal/redux/store";
import { setLanguage } from "@portal/redux/reducers/languageReducer";
import { clearRiskLevelData } from "@portal/redux/reducers/riskLevelReducer";
import { clearSavingCalculationsData } from "@portal/redux/reducers/savingCalculationsReducer";
import { clearSavingAgreementData } from "@portal/redux/reducers/ui/createSavingsAgreement";
import { clearSavingProposalData } from "@portal/redux/reducers/savingProposalReducer";

export const ClearReduxData = (dispatch: AppDispatch) => {
  dispatch(clearRiskLevelData());
  dispatch(clearSavingAgreementData());
  dispatch(clearSavingCalculationsData());
  dispatch(clearSavingProposalData());
  dispatch(setLanguage(true));
};
